import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@nestle-npus-nbm/pds-ui';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';

import { NerdMenuElementType } from 'src/common/enums';
import NerdMenuComponent from './NerdMenuComponent';
import NerdMenuLinkListWrapper from './NerdMenuLinkListWrapper';

type NerdMenuStackedProps = {
  nerdMenu: NerdMenu;
};

const NerdMenuStacked: React.FC<NerdMenuStackedProps> = ({ nerdMenu }) => {
  const columns = nerdMenu.menuElements.filter(
    element => element.type === NerdMenuElementType.COLUMN,
  );
  return (
    <div className="pds-flex pds-flex-col pds-gap-5">
      {columns.length > 0 ? (
        <Accordion collapsible options={{ headingLevel: 'h2' }} type="single" asChild>
          <ul className="pds-m-0 pds-list-none pds-p-0">
            {columns.map(menuElement => {
              // Filter elements to include only those of type LINK_LISTS_WRAPPER, as required for the menu structure.
              const linkListWrappers =
                menuElement.menuElements?.filter(
                  x => x.type === NerdMenuElementType.LINK_LISTS_WRAPPER,
                ) || [];

              const innerComponents =
                menuElement.menuElements?.filter(
                  element => element.type === NerdMenuElementType.COMPONENT,
                ) || [];

              return (
                <React.Fragment key={menuElement.drupal_id}>
                  {linkListWrappers.map(linkListWrapper => {
                    return (
                      <AccordionItem
                        value={linkListWrapper.drupal_id}
                        key={linkListWrapper.drupal_id}
                        asChild
                      >
                        <li className="first:pds-border-t [&_>_*:first-child]:pds-mb-0">
                          <AccordionTrigger
                            className="pds-px-4 pds-py-4.5 pds-text-title-sm pds-font-extrabold pds-text-neutral-text"
                            iconBtnClass="[&_svg]:pds-fill-neutral-text"
                            onClick={() => {
                              sendIt({
                                event: 'nav_click',
                                eventParams: {
                                  nav_item: linkListWrapper.title,
                                  nav_type: 'footer',
                                },
                              });
                            }}
                          >
                            {linkListWrapper.title}
                          </AccordionTrigger>

                          <AccordionContent className="pds-pb-4.5">
                            <div className="pds-flex pds-flex-col pds-gap-5">
                              <NerdMenuLinkListWrapper
                                // for now let's not use it;
                                isMobileStack
                                linkListWrapper={linkListWrapper}
                              />
                            </div>
                          </AccordionContent>
                        </li>
                      </AccordionItem>
                    );
                  })}
                  {innerComponents.length > 0 && (
                    <li className="pds-mt-5 pds-space-y-5">
                      {innerComponents.map(component => {
                        return (
                          <NerdMenuComponent component={component} key={component.drupal_id} />
                        );
                      })}
                    </li>
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        </Accordion>
      ) : null}
    </div>
  );
};

export default NerdMenuStacked;
